export const setTimer = ()=> {
        const now = new Date();
        const setLogoutTime = new Date(now.setHours(now.getHours() + 2))
        setLogoutTime.getTime()
        return setLogoutTime
        } 